var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g8, _g9, _g10, _g11, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLearningToLearn = function SvgLearningToLearn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 216,
    viewBox: "0 0 214 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mind_Mapping"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right-2",
    d: "M207.464 172.335H186.698C186.178 172.335 185.751 171.602 185.751 170.696V142.999C185.751 142.092 186.178 141.359 186.698 141.359H207.464C208.237 141.359 208.69 142.865 208.237 143.945L203.279 155.901C203.039 156.474 203.039 157.234 203.279 157.793L208.237 169.749C208.69 170.829 208.237 172.335 207.464 172.335Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left-2",
    d: "M11.2388 141.359H32.0049C32.5247 141.359 32.9512 142.092 32.9512 142.999V170.696C32.9512 171.602 32.5247 172.335 32.0049 172.335H11.2388C10.4657 172.335 10.0125 170.829 10.4657 169.749L15.424 157.793C15.6639 157.22 15.6639 156.461 15.424 155.901L10.4657 143.945C10.0125 142.865 10.4657 141.359 11.2388 141.359Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-2",
    filter: "url(#filter0_d_1241_129307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5408 57.9482V155.688C24.5408 161.899 28.5527 167.39 34.4574 169.283L102.58 191.102C105.406 192.008 108.458 192.008 111.284 191.102L179.407 169.283C185.311 167.39 189.323 161.899 189.323 155.688V57.9482C189.323 51.5904 185.125 46.0057 179.007 44.233L110.884 24.5598C108.298 23.8134 105.553 23.8134 102.967 24.5598L34.8439 44.233C28.7393 45.9923 24.5275 51.5904 24.5275 57.9482H24.5408Z",
    fill: "url(#paint0_linear_1241_129307)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Front-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8589 61.7202V152.062C29.8589 158.18 33.8176 163.605 39.6422 165.471L102.634 185.65C105.433 186.543 108.432 186.543 111.217 185.65L174.209 165.471C180.033 163.605 183.992 158.18 183.992 152.062V61.7202C183.992 55.4557 179.847 49.9376 173.822 48.1916L110.831 29.9979C108.285 29.2649 105.566 29.2649 103.02 29.9979L40.0287 48.1916C34.0042 49.9376 29.8589 55.4424 29.8589 61.7202Z",
    fill: "url(#paint1_linear_1241_129307)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_129307",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 29,
    width: 155,
    height: 158
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Front-4",
    d: "M29.8589 61.9201V152.262C29.8589 158.38 33.8176 163.805 39.6422 165.671L102.634 185.85C105.433 186.743 108.432 186.743 111.217 185.85L174.209 165.671C180.033 163.805 183.992 158.38 183.992 152.262V61.9201C183.992 55.6556 179.847 50.1375 173.822 48.3914L110.831 30.1978C108.285 29.4647 105.566 29.4647 103.02 30.1978L40.0287 48.3914C34.0042 50.1375 29.8589 55.6422 29.8589 61.9201Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_129307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M106.939 235.526C161.714 235.526 206.118 209.287 206.118 176.92C206.118 144.553 161.714 118.314 106.939 118.314C52.1638 118.314 7.75995 144.553 7.75995 176.92C7.75995 209.287 52.1638 235.526 106.939 235.526Z",
    fill: "#F28723"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Stars-2",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.7531 131.269C67.6523 131.269 69.1919 129.73 69.1919 127.831C69.1919 125.931 67.6523 124.392 65.7531 124.392C63.8539 124.392 62.3143 125.931 62.3143 127.831C62.3143 129.73 63.8539 131.269 65.7531 131.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M167.918 122.992L165.918 126.271C165.612 126.777 164.865 126.777 164.545 126.271L162.546 122.992C162.386 122.739 162.386 122.419 162.546 122.152L164.545 118.874C164.852 118.367 165.598 118.367 165.918 118.874L167.918 122.152C168.077 122.406 168.077 122.739 167.918 122.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M174.342 115.941L172.769 118.514C172.529 118.914 171.943 118.914 171.69 118.514L170.117 115.941C169.997 115.741 169.997 115.488 170.117 115.288L171.69 112.716C171.93 112.316 172.516 112.316 172.769 112.716L174.342 115.288C174.462 115.488 174.462 115.741 174.342 115.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.2263 57.0684L84.0534 58.9744C83.8668 59.2677 83.4403 59.2677 83.2537 58.9744L82.0941 57.0684C82.0008 56.9218 82.0008 56.7352 82.0941 56.5753L83.2537 54.6693C83.4403 54.376 83.8668 54.376 84.0534 54.6693L85.2263 56.5753C85.3196 56.7219 85.3196 56.9085 85.2263 57.0684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M81.2011 50.5374L78.9352 54.2428C78.5753 54.8159 77.7356 54.8159 77.3891 54.2428L75.1232 50.5374C74.9499 50.2442 74.9499 49.8843 75.1232 49.591L77.3891 45.8857C77.7489 45.3125 78.5887 45.3125 78.9352 45.8857L81.2011 49.591C81.3743 49.8843 81.3743 50.2442 81.2011 50.5374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.9319 120.74C50.8889 120.74 51.6647 119.964 51.6647 119.007C51.6647 118.05 50.8889 117.274 49.9319 117.274C48.975 117.274 48.1992 118.05 48.1992 119.007C48.1992 119.964 48.975 120.74 49.9319 120.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M57.9691 136.201C59.3825 136.201 60.5282 135.055 60.5282 133.642C60.5282 132.228 59.3825 131.083 57.9691 131.083C56.5558 131.083 55.41 132.228 55.41 133.642C55.41 135.055 56.5558 136.201 57.9691 136.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M168.517 110.81L167.105 113.116C166.878 113.475 166.358 113.475 166.145 113.116L164.732 110.81C164.625 110.623 164.625 110.397 164.732 110.223L166.145 107.917C166.371 107.557 166.891 107.557 167.105 107.917L168.517 110.223C168.624 110.41 168.624 110.636 168.517 110.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M148.911 50.3774C150.258 50.3774 151.35 49.2854 151.35 47.9383C151.35 46.5912 150.258 45.4991 148.911 45.4991C147.564 45.4991 146.472 46.5912 146.472 47.9383C146.472 49.2854 147.564 50.3774 148.911 50.3774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M139.421 49.5643C140.378 49.5643 141.154 48.7886 141.154 47.8316C141.154 46.8747 140.378 46.0989 139.421 46.0989C138.464 46.0989 137.688 46.8747 137.688 47.8316C137.688 48.7886 138.464 49.5643 139.421 49.5643Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shine-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_129307",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 166,
    height: 168
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.5408 58.0148V155.608C24.5408 161.859 28.5794 167.39 34.524 169.296L102.554 191.089C105.406 192.008 108.472 192.008 111.324 191.089L179.354 169.296C185.311 167.39 189.337 161.859 189.337 155.608V58.0148C189.337 51.6171 185.098 45.979 178.954 44.2063L110.924 24.5598C108.325 23.8134 105.553 23.8134 102.953 24.5598L34.9238 44.2063C28.7793 45.979 24.5408 51.6171 24.5408 58.0148Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_129307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.15,
    d: "M15.9838 241.671C13.3847 234.42 12.0785 230.328 9.47937 221.185C26.9 208.256 45.6135 199.512 64.1404 188.503C83.7336 176.867 99.6347 161.659 116.935 146.957C152.75 116.554 179.114 111.196 224.405 123.365C227.004 125.698 228.31 126.897 230.909 129.497C184.738 115.861 158.694 126.684 123.44 157.673C89.1183 187.863 48.3059 209.802 15.9705 241.658L15.9838 241.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.15,
    d: "M5.96062 225.503C-9.87387 197.433 -16.9114 164.351 -24.2955 133.389C23.0747 134.148 48.3725 110.397 83.1738 81.3667C118.695 51.737 146.378 43.8864 190.643 58.5746C201.119 68.9843 211.169 79.2207 220.899 90.3369C174.862 68.4778 144.859 98.4007 113.43 130.536C79.4284 165.311 41.3217 192.648 5.96062 225.503Z",
    fill: "white"
  })))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M182.886 178.906C131.917 159.886 83.4403 159.833 32.4447 178.746C30.5787 179.533 28.4727 178.853 27.7397 177.2C25.3138 167.004 24.2076 161.859 22.2482 151.516C21.5551 149.836 22.7681 147.744 24.9673 146.891C80.2414 128.39 132.556 128.67 187.577 147.957C189.763 148.797 190.976 150.863 190.296 152.542C189.537 162.552 188.99 167.523 187.591 177.373C186.858 179.026 184.752 179.692 182.886 178.906Z",
    fill: "#4539FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M37.9361 164.964L40.7485 163.978L41.335 165.644L36.3633 167.377L33.2844 158.54L35.4303 157.793L37.9361 164.964Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M43.1876 157.18L43.7341 158.993L46.6531 158.1L47.1729 159.779L44.2539 160.672L44.8537 162.632L48.1592 161.632L48.6924 163.378L43.2142 165.044L40.4819 156.101L45.96 154.435L46.4931 156.181L43.1876 157.18Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M56.1565 159.673L52.771 160.539L52.6377 162.285L50.3318 162.872L51.2915 152.968L53.8506 152.315L59.4487 160.539L57.1161 161.139L56.1698 159.673H56.1565ZM55.1568 158.113L53.1842 155.088L52.9176 158.686L55.1568 158.113Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M65.9263 159.18L63.3006 156.114L62.7675 156.221L63.4872 159.673L61.2613 160.139L59.3687 150.982L63.114 150.209C63.8338 150.063 64.4735 150.063 65.0333 150.209C65.5932 150.356 66.0463 150.623 66.3929 151.009C66.7394 151.396 66.966 151.862 67.0726 152.395C67.1926 153.008 67.1393 153.582 66.8994 154.128C66.6594 154.675 66.2196 155.128 65.5931 155.461L68.4588 158.646L65.9397 159.166L65.9263 159.18ZM62.4476 154.648L63.8337 154.368C64.2469 154.288 64.5268 154.115 64.6868 153.875C64.8467 153.635 64.9001 153.328 64.8201 152.968C64.7534 152.622 64.5935 152.369 64.3402 152.209C64.1003 152.049 63.7671 152.009 63.3539 152.102L61.9677 152.395L62.4342 154.661L62.4476 154.648Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M78.8685 156.927L76.616 157.287L71.9376 152.182L72.844 157.887L70.5914 158.247L69.1119 149.01L71.3645 148.65L76.0428 153.782L75.1232 148.05L77.3757 147.69L78.8552 156.927H78.8685Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M82.5072 147.064L83.6535 156.354L81.3876 156.634L80.2414 147.344L82.5072 147.064Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M94.5164 155.301L92.2505 155.501L87.9454 150.076L88.4519 155.821L86.186 156.021L85.3729 146.704L87.6388 146.504L91.944 151.942L91.4375 146.171L93.7034 145.971L94.5164 155.288V155.301Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M102.94 148.53C102.754 148.223 102.514 147.997 102.194 147.85C101.874 147.69 101.501 147.624 101.074 147.65C100.341 147.677 99.7546 147.944 99.3281 148.437C98.9016 148.943 98.7017 149.596 98.7283 150.396C98.755 151.262 99.0216 151.915 99.5014 152.382C99.9812 152.848 100.634 153.062 101.447 153.035C102.007 153.008 102.474 152.862 102.847 152.555C103.22 152.262 103.487 151.836 103.647 151.302L100.754 151.409L100.688 149.73L105.646 149.543L105.726 151.662C105.579 152.235 105.313 152.782 104.926 153.275C104.54 153.781 104.046 154.195 103.433 154.515C102.82 154.834 102.127 155.021 101.341 155.048C100.421 155.088 99.5814 154.914 98.8483 154.528C98.1152 154.155 97.5287 153.608 97.0889 152.902C96.6624 152.195 96.4225 151.382 96.3958 150.463C96.3558 149.543 96.5291 148.703 96.9156 147.97C97.2888 147.237 97.8353 146.651 98.5417 146.211C99.2481 145.784 100.061 145.544 100.981 145.518C102.101 145.478 103.06 145.718 103.847 146.224C104.633 146.731 105.166 147.464 105.459 148.423L102.94 148.517V148.53Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M118.721 145.664L118.668 147.49L116.189 147.424L115.989 154.954L113.71 154.888L113.91 147.357L111.431 147.29L111.484 145.464L118.721 145.651V145.664Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M122.493 154.728C121.787 154.261 121.254 153.648 120.881 152.888C120.507 152.129 120.347 151.289 120.414 150.369C120.481 149.45 120.761 148.65 121.24 147.957C121.72 147.264 122.347 146.731 123.106 146.384C123.866 146.024 124.693 145.891 125.559 145.944C126.425 145.997 127.225 146.277 127.932 146.731C128.638 147.197 129.171 147.797 129.531 148.557C129.891 149.316 130.051 150.156 129.984 151.062C129.917 151.969 129.638 152.782 129.158 153.475C128.678 154.168 128.065 154.701 127.305 155.061C126.545 155.421 125.732 155.554 124.853 155.501C123.973 155.448 123.186 155.168 122.48 154.714L122.493 154.728ZM126.852 152.835C127.332 152.369 127.612 151.729 127.665 150.916C127.732 150.089 127.545 149.423 127.145 148.89C126.732 148.37 126.159 148.077 125.412 148.023C124.653 147.97 124.04 148.17 123.56 148.623C123.08 149.076 122.8 149.716 122.747 150.556C122.68 151.382 122.867 152.049 123.266 152.582C123.68 153.102 124.266 153.395 125.013 153.448C125.759 153.502 126.372 153.302 126.852 152.835Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M137.981 155.034L140.94 155.434L140.7 157.18L135.489 156.461L136.755 147.197L139.008 147.504L137.981 155.034Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M146.165 150.463L145.845 152.329L148.858 152.848L148.551 154.581L145.539 154.061L145.179 156.087L148.578 156.687L148.258 158.486L142.606 157.5L144.219 148.29L149.871 149.276L149.551 151.076L146.152 150.476L146.165 150.463Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M156.615 158.553L153.203 157.793L152.296 159.286L149.964 158.766L155.295 150.369L157.868 150.943L159.147 160.806L156.788 160.286L156.601 158.553H156.615ZM156.428 156.714L156.042 153.115L154.176 156.207L156.428 156.714Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M165.558 162.552L164.612 158.633L164.079 158.487L163.146 161.899L160.947 161.299L163.426 152.275L167.118 153.288C167.824 153.488 168.397 153.768 168.837 154.155C169.277 154.541 169.557 154.981 169.677 155.488C169.81 155.994 169.797 156.501 169.65 157.034C169.49 157.634 169.17 158.127 168.704 158.5C168.237 158.873 167.651 159.073 166.931 159.086L168.038 163.232L165.558 162.552ZM164.519 156.927L165.878 157.3C166.278 157.407 166.611 157.394 166.865 157.247C167.118 157.1 167.291 156.86 167.398 156.501C167.491 156.154 167.464 155.861 167.318 155.608C167.171 155.354 166.891 155.168 166.491 155.061L165.132 154.688L164.519 156.927Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M178.101 166.47L175.941 165.764L174.115 159.086L172.316 164.564L170.157 163.858L173.076 154.968L175.235 155.674L177.048 162.365L178.86 156.86L181.02 157.567L178.101 166.457V166.47Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M129.011 95.3219L140.514 76.022",
    stroke: "#7B60F9",
    strokeWidth: 0.91968,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M126.545 108.957L138.674 116.781",
    stroke: "#7B60F9",
    strokeWidth: 0.91968,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M85.3063 86.085L70.0716 80.6736",
    stroke: "#7B60F9",
    strokeWidth: 0.91968,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M140.514 77.1949C141.162 77.1949 141.687 76.6697 141.687 76.0219C141.687 75.3741 141.162 74.849 140.514 74.849C139.866 74.849 139.341 75.3741 139.341 76.0219C139.341 76.6697 139.866 77.1949 140.514 77.1949Z",
    fill: "#7B60F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M137.035 116.794C137.683 116.794 138.208 116.269 138.208 115.621C138.208 114.974 137.683 114.448 137.035 114.448C136.387 114.448 135.862 114.974 135.862 115.621C135.862 116.269 136.387 116.794 137.035 116.794Z",
    fill: "#7B60F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M71.9243 82.3398C72.5721 82.3398 73.0972 81.8146 73.0972 81.1668C73.0972 80.519 72.5721 79.9939 71.9243 79.9939C71.2765 79.9939 70.7513 80.519 70.7513 81.1668C70.7513 81.8146 71.2765 82.3398 71.9243 82.3398Z",
    fill: "#7B60F9"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_38",
    filter: "url(#filter1_d_1241_129307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.346 78.8209H85.6129C82.3666 78.8209 79.7349 81.4526 79.7349 84.6989V108.211C79.7349 111.457 82.3666 114.089 85.6129 114.089H123.346C126.593 114.089 129.224 111.457 129.224 108.211V84.6989C129.224 81.4526 126.593 78.8209 123.346 78.8209Z",
    fill: "url(#paint2_linear_1241_129307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.346 78.8209H85.6129C82.3666 78.8209 79.7349 81.4526 79.7349 84.6989V108.211C79.7349 111.457 82.3666 114.089 85.6129 114.089H123.346C126.593 114.089 129.224 111.457 129.224 108.211V84.6989C129.224 81.4526 126.593 78.8209 123.346 78.8209Z",
    stroke: "#61D4ED",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_39",
    filter: "url(#filter2_d_1241_129307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7531 68.0647H45.067C42.0562 68.0647 39.6155 70.5054 39.6155 73.5161V86.4583C39.6155 89.469 42.0562 91.9098 45.067 91.9098H65.7531C68.7638 91.9098 71.2045 89.469 71.2045 86.4583V73.5161C71.2045 70.5054 68.7638 68.0647 65.7531 68.0647Z",
    fill: "url(#paint3_linear_1241_129307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7531 68.0647H45.067C42.0562 68.0647 39.6155 70.5054 39.6155 73.5161V86.4583C39.6155 89.469 42.0562 91.9098 45.067 91.9098H65.7531C68.7638 91.9098 71.2045 89.469 71.2045 86.4583V73.5161C71.2045 70.5054 68.7638 68.0647 65.7531 68.0647Z",
    stroke: "#61D4ED",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_40",
    filter: "url(#filter3_d_1241_129307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.826 107.078H143.139C140.129 107.078 137.688 109.518 137.688 112.529V125.471C137.688 128.482 140.129 130.923 143.139 130.923H163.826C166.836 130.923 169.277 128.482 169.277 125.471V112.529C169.277 109.518 166.836 107.078 163.826 107.078Z",
    fill: "url(#paint4_linear_1241_129307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.826 107.078H143.139C140.129 107.078 137.688 109.518 137.688 112.529V125.471C137.688 128.482 140.129 130.923 143.139 130.923H163.826C166.836 130.923 169.277 128.482 169.277 125.471V112.529C169.277 109.518 166.836 107.078 163.826 107.078Z",
    stroke: "#61D4ED",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_41",
    filter: "url(#filter4_d_1241_129307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.091 63.8928H146.405C143.394 63.8928 140.954 66.3335 140.954 69.3443V82.2864C140.954 85.2972 143.394 87.7379 146.405 87.7379H167.091C170.102 87.7379 172.543 85.2972 172.543 82.2864V69.3443C172.543 66.3335 170.102 63.8928 167.091 63.8928Z",
    fill: "url(#paint5_linear_1241_129307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.091 63.8928H146.405C143.394 63.8928 140.954 66.3335 140.954 69.3443V82.2864C140.954 85.2972 143.394 87.7379 146.405 87.7379H167.091C170.102 87.7379 172.543 85.2972 172.543 82.2864V69.3443C172.543 66.3335 170.102 63.8928 167.091 63.8928Z",
    stroke: "#61D4ED",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M88.8118 92.9626H120.161",
    stroke: "#7B60F9",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M94.0766 100.08H114.883",
    stroke: "#7B60F9",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M146.885 72.4897H166.625",
    stroke: "#7B60F9",
    strokeWidth: 2.5991,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M146.885 79.2607H166.625",
    stroke: "#7B60F9",
    strokeWidth: 1.29288,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M144.526 115.728H162.426",
    stroke: "#7B60F9",
    strokeWidth: 2.47914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M144.526 122.499H162.426",
    stroke: "#7B60F9",
    strokeWidth: 1.23957,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M45.9467 76.6084H64.8734",
    stroke: "#7B60F9",
    strokeWidth: 2.54578,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M45.9467 83.3794H64.8734",
    stroke: "#7B60F9",
    strokeWidth: 1.26623,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_129307",
    x: 0.535812,
    y: 0.00834656,
    width: 212.779,
    height: 215.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1241_129307",
    x: 79.0685,
    y: 78.1545,
    width: 51.782,
    height: 37.5603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.959666,
    dy: 0.959666
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1241_129307",
    x: 38.9491,
    y: 67.3983,
    width: 33.8815,
    height: 26.1375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.959666,
    dy: 0.959666
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1241_129307",
    x: 137.022,
    y: 106.411,
    width: 33.8816,
    height: 26.1375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.959666,
    dy: 0.959666
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1241_129307",
    x: 140.287,
    y: 63.2264,
    width: 33.8816,
    height: 26.1375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.959666,
    dy: 0.959666
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_129307",
    x1: 106.939,
    y1: 104.772,
    x2: 106.939,
    y2: 269.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_129307",
    x1: 106.939,
    y1: 252.654,
    x2: 106.939,
    y2: -51.3604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1241_129307",
    x1: 104.486,
    y1: 113.182,
    x2: 104.486,
    y2: 63.6929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#61D4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B60F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1241_129307",
    x1: 55.41,
    y1: 93.0027,
    x2: 55.41,
    y2: 61.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#61D4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B60F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1241_129307",
    x1: 153.389,
    y1: 130.283,
    x2: 153.656,
    y2: 98.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#61D4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B60F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1241_129307",
    x1: 156.748,
    y1: 90.3903,
    x2: 156.748,
    y2: 58.8013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#61D4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B60F9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLearningToLearn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "learning-to-learn.711b7a9.svg";